import { Component, OnInit, ViewChild, Input } from "@angular/core";
import { DocumentService } from "@shared/services/document.service";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { WizardService } from "@shared/services/wizard.service";
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-document-viewer",
  templateUrl: "./document-viewer.component.html",
  styleUrls: ["./document-viewer.component.scss"],
  imports: [TranslateModule]
})
export class DocumentViewerComponent implements OnInit {
  private _destroy$ = new Subject<any>();
  src: string;
  title: string;
  
  @ViewChild("pdfViewerOnDemand", { static: false }) pdfViewerOnDemand;
  @Input() id: number;

  constructor(
    private documentService: DocumentService,
    private wizardService: WizardService,
    private activatedRoute: ActivatedRoute,
    private location: Location,
  ) {}

  ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      if (!isNaN(params.id)) {
        this.documentService
        .downloadDocument(`${params.id}`)
        .pipe(takeUntil(this._destroy$))
        .subscribe((res) => {
          this.pdfViewerOnDemand.pdfSrc = res;
          this.pdfViewerOnDemand.refresh();
        });
      }else {
        this.documentService
          .downloadDocument(`${this.wizardService._currentData.pdfBlob.enReportId}`)
          .pipe(takeUntil(this._destroy$))
          .subscribe((res) => {
            this.pdfViewerOnDemand.pdfSrc = res;
            this.pdfViewerOnDemand.refresh();
          });
      }
    });


  }

  returnPreviousLocation(event) {
    event && event.preventDefault();
    this.location.back();
  }
}
